<h1 mat-dialog-title style="word-wrap: break-word; word-break: break-all; font-family: sans-serif;">
 {{"title.confirmationheader" | translate | async }}"{{getDisplayName(this.data.name)}}"?
  
</h1>
<p mat-dialog-content style="font-family: sans-serif;">
   {{"message.capacityconfirmation" | translate | async }}<br>
   {{"message.capacityconfirmationmessage" | translate | async }}
</p>


<div mat-dialog-actions>
  <vue-basic-button (clicked)="data.onLeave()">
    {{ "button.cancel" |translate | async }} 
  </vue-basic-button>
  <vue-flat-button (clicked)="data.onStay()">
    {{ "button.ok" |translate | async }} 
  </vue-flat-button>
</div>
